import {LANGUAGE} from '@/common/utils/constants';

export const FAQ_PAGE = {
	[LANGUAGE.en.short]: {
		resources: 'RESOURCES',
		description: 'Access helpful content assets to help you navigate our platform',
		nowPlaying: 'NOW PLAYING',
		upNext: 'UP NEXT',
		watchMore: 'Watch more videos',
		videoTypes: {
			popular: 'Popular',
			howSubmitStory: 'How to submit a story',
			features: 'Features',
			howSearch: 'How to effectively search'
		},
		curatedForYou: 'Curated for you',
		download: 'Download',
		pageTitle: "FAQs",
		contact: `Didn't find what you were looking for? Feel free to ask a question.`,
		submit: 'Submit',
		questionPlaceholder: 'Type your message here',
		helpUs: 'Help Us Make This Better for You',
		weListening: 'We’re Listening! Take Our Weekly Survey!',
		takeTheSurvey: 'TAKE THE SURVEY',
		helpful: 'Helpful',
		notHelpful: 'Not Helpful',


		pageMainButton: "Ask a question",
		faqVideoTitle: "Watch How to Submit your Client Story Video",
		translationsVideoTitle :"See how translations and validations work",
		questions: [
			{
				title: "How can I submit a success story?",
				answer: "You can start by tapping on the “SHARE YOUR SUCCESS STORY” button on the home page or by clicking on the ‘Create’ button in the menu on the left while on the home page.",
				fileName: false,
				index: 1
			},
			{
				title: "Can I download a success story?",
				answer: "Yes, you can download a reference project in Word, PDF, or PPT format by opening the project page and tapping on the “Download” button.",
				fileName: false,
				index: 2
			},
			{
				title: "Can I submit a success story in a language different than English?",
				answer: "Yes. You can submit in German, Italian, French, and Japanese. If you submit your project in one of the listed languages, it will be auto-translated and then edited by the CMT in English. After you approve the English version of your project, it will be published, and you can review, edit, and validate it in Italian, French, Japanese, and German.",
				fileName: false,
				index: 3
			},
			{
				title: "Can I make changes to translations of published projects?",
				answer: "Yes. You can revise a translated project by pressing the 'Edit the translation'. If the project is already validated, you can report a problem in that project.",
				fileName: false,
				index: 4
			},
			{
				title: "When will my project be published?",
				answer: "After you submit your project, the content manager will review and edit it and send it to you for your review and approval. Upon receiving your approval, the CMT will publish your story.",
				fileName: false,
				index: 5
			},
			{
				title: "How can I report an error that I see in a success story?",
				answer: "To report an error on a story page, tap the red “Report a problem” button above the side menu on the right.",
				fileName: false,
				index: 6
			},
			{
				title: "Can I preview projects in other languages?",
				answer: "Yes. When you open a story page, you can change its language by pressing the language/country icon at the top right navigation menu.",
				fileName: false,
				index: 7
			}
		]
	},
	[LANGUAGE.de.short]: {
		resources: 'RESSOURCEN',
		description: 'Greifen Sie auf hilfreiche Inhalte zu, die Ihnen die Navigation auf unserer Plattform erleichtern',
		nowPlaying: 'JETZT LÄUFT',
		upNext: 'NÄCHSTES',
		watchMore: 'Weitere Videos ansehen',
		videoTypes: {
			popular: 'Beliebte Beiträge',
			howSubmitStory: 'Wie man eine Geschichte einreicht',
			features: 'Funktionen',
			howSearch: 'Wie man effektiv sucht'
		},
		curatedForYou: 'Für Sie kuratiert',
		download: 'Herunterladen',
		pageTitle: "FAQs",
		contact: 'Nicht gefunden, wonach Sie gesucht haben? Stellen Sie gern eine Frage.',
		submit: 'Einreichen',
		questionPlaceholder: 'Geben Sie hier Ihre Nachricht ein',
		helpUs: 'Helfen Sie uns, es für Sie zu verbessern.',
		weListening: 'Wir hören Ihnen zu! Nehmen Sie an unserer wöchentlichen Umfrage teil!',
		takeTheSurvey: 'Nehmen Sie an der Umfrage teil',
		helpful: 'Hilfreich',
		notHelpful: 'Nicht hilfreich',


		pageMainButton: "Stelle eine Frage",
		faqVideoTitle: "Sehen Sie sich das Video an, wie Sie Ihr Referenzprojekt einreichen",
		translationsVideoTitle: "Sehen Sie, wie Übersetzungen und Validierungen funktionieren",
		questions: [
			{
				title: "Wie kann ich eine Erfolgsgeschichte einreichen?",
				answer: "Sie können beginnen, indem Sie auf der Startseite auf die Schaltfläche „TEILEN SIE IHRE ERFOLGSGESCHICHTE“ tippen oder auf der Startseite im Menü links auf die Schaltfläche „Erstellen“ klicken..",
				fileName: false,
				index: 1
			},
			{
				title: "Kann ich eine Erfolgsgeschichte herunterladen?",
				answer: "Ja, Sie können ein Referenzprojekt im Word-, PDF- oder PPT-Format herunterladen, indem Sie die Projektseite öffnen und auf die Schaltfläche „Herunterladen“ tippen.",
				fileName: false,
				index: 2
			},
			{
				title: "Kann ich eine Erfolgsgeschichte in einer anderen Sprache als Englisch einreichen??",
				answer: "Ja. Sie können auf Deutsch, Italienisch, Französisch und Japanisch einreichen. Wenn Sie Ihr Projekt in einer der aufgeführten Sprachen einreichen, wird es automatisch übersetzt und dann vom CMT auf Englisch bearbeitet. Nachdem Sie die englische Version Ihres Projekts genehmigt haben, wird es veröffentlicht und Sie können es auf Italienisch, Französisch, Japanisch und Deutsch überprüfen, bearbeiten und validieren.",
				fileName: false,
				index: 3
			},
			{
				title: "Kann ich Änderungen an Übersetzungen veröffentlichter Projekte vornehmen??",
				answer: "Ja. Sie können ein übersetztes Projekt überarbeiten, indem Sie auf „Übersetzung bearbeiten“ klicken. Wenn das Projekt bereits validiert ist, können Sie ein Problem in diesem Projekt melden..",
				fileName: false,
				index: 4
			},
			{
				title: "Wann wird mein Projekt veröffentlicht?",
				answer: "Nachdem Sie Ihr Projekt eingereicht haben, wird der Content Manager es überprüfen, bearbeiten und Ihnen zur Überprüfung und Genehmigung zusenden. Nach Erhalt Ihrer Genehmigung veröffentlicht das CMT Ihre Geschichte.",
				fileName: false,
				index: 5
			},
			{
				title: "Wie kann ich einen Fehler melden, den ich in einer Erfolgsgeschichte sehe??",
				answer: "Um einen Fehler auf einer Story-Seite zu melden, tippen Sie auf die rote Schaltfläche „Problem melden“ über dem Seitenmenü rechts.",
				fileName: false,
				index: 6
			},
			{
				title: "Kann ich eine Vorschau von Projekten in anderen Sprachen anzeigen??",
				answer: "Ja. Wenn Sie eine Story-Seite öffnen, können Sie deren Sprache ändern, indem Sie oben rechts im Navigationsmenü auf das Sprach-/Ländersymbol klicken..",
				fileName: false,
				index: 7
			}
		]
	},
	[LANGUAGE.fr.short]: {
		resources: 'RESSOURCES',
		description: 'Accédez à des ressources de contenu utiles pour vous aider à naviguer sur notre plateforme',
		nowPlaying: 'EN COURS DE LECTURE',
		upNext: 'SUIVANT',
		watchMore: 'Regardez plus de vidéos',
		videoTypes: {
			popular: 'Populaire',
			howSubmitStory: 'Comment soumettre un article',
			features: 'Fonctionnalités',
			howSearch: 'Comment effectuer une recherche efficace'
		},
		curatedForYou: 'Conçu pour vous',
		download: 'Télécharger',
		pageTitle: "FAQs",
		contact: 'Vous n\'avez pas trouvé ce que vous cherchiez ? N\'hésitez pas à poser une question.',
		submit: 'Soumettre',
		questionPlaceholder: 'Tapez votre message ici',
		helpUs: 'Aidez-nous à améliorer votre expérience.',
		weListening: 'Nous sommes à votre écoute! Répondez à notre enquête hebdomadaire!',
		takeTheSurvey: 'RÉPONDRE À L\'ENQUÊTE',
		helpful: 'Utile',
		notHelpful: 'Pas utile',


		pageMainButton: "Poser une question",
		faqVideoTitle: "Regardez comment soumettre votre projet de référence Vidéo",
		translationsVideoTitle: "Voir comment les traductions et les validations fonctionnent",
		questions: [
			{
				title: "Comment puis-je soumettre une histoire de réussite?",
				answer: "Vous pouvez commencer en appuyant sur le bouton « PARTAGEZ VOTRE SUCCESS STORY » sur la page d’accueil ou en cliquant sur le bouton « Créer » dans le menu de gauche lorsque vous êtes sur la page d’accueil.",
				fileName: false,
				index: 1
			},
			{
				title: "Puis-je télécharger une histoire de réussite?",
				answer: "Oui, vous pouvez télécharger un projet de référence au format Word, PDF ou PPT en ouvrant la page du projet et en appuyant sur le bouton « Télécharger »",
				fileName: false,
				index: 2
			},
			{
				title: "Puis-je soumettre une histoire de réussite dans une langue autre que l'anglais ??",
				answer: "Oui. Vous pouvez soumettre votre projet en allemand, en italien, en français et en japonais. Si vous soumettez votre projet dans l'une des langues répertoriées, il sera automatiquement traduit puis édité par le CMT en anglais. Une fois que vous aurez approuvé la version anglaise de votre projet, il sera publié et vous pourrez le réviser, le modifier et le valider en italien, en français, en japonais et en allemand.",
				fileName: false,
				index: 3
			},
			{
				title: "Puis-je apporter des modifications aux traductions de projets publiés?",
				answer: "Oui. Vous pouvez réviser un projet traduit en cliquant sur « Modifier la traduction ». Si le projet est déjà validé, vous pouvez signaler un problème dans ce projet.",
				fileName: false,
				index: 4
			},
			{
				title: "Quand mon projet sera-t-il publié?",
				answer: "Après avoir soumis votre projet, le gestionnaire de contenu l'examinera et le modifiera, puis vous l'enverra pour examen et approbation. Après avoir reçu votre approbation, le CMT publiera votre histoire.",
				fileName: false,
				index: 5
			},
			{
				title: "Comment puis-je signaler une erreur que je vois dans une histoire de réussite?",
				answer: "Pour signaler une erreur sur une page d'histoire, appuyez sur le bouton rouge «Signaler un problème» au-dessus du menu latéral à droite.",
				fileName: false,
				index: 6
			},
			{
				title: "Puis-je prévisualiser des projets dans d'autres langues?",
				answer: "Oui. Lorsque vous ouvrez une page d'histoire, vous pouvez changer sa langue en appuyant sur l'icône langue/pays dans le menu de navigation en haut à droite.",
				fileName: false,
				index: 7
			}
		]
	},
	[LANGUAGE.it.short]: {
		resources: 'RISORSE',
		description: 'Accedi a risorse di contenuti utili per aiutarti a navigare sulla nostra piattaforma',
		nowPlaying: 'ORA IN RIPRODUZIONE',
		upNext: 'PROSSIMAMENTE',
		watchMore: 'Guarda altri video',
		videoTypes: {
			popular: 'Popolari',
			howSubmitStory: 'Come inviare un articolo',
			features: 'Funzionalità',
			howSearch: 'Come effettuare ricerche in modo efficace'
		},
		curatedForYou: 'Selezionato per te',
		download: 'Scaricamento',
		pageTitle: "FAQs",
		contact: 'Non hai trovato quello che cercavi? Non esitare a fare una domanda.',
		submit: 'Invia',
		questionPlaceholder: 'Scrivi qui il tuo messaggio',
		helpUs: 'Aiutaci a migliorare la tua esperienza',
		weListening: 'Ti ascoltiamo! Partecipa al nostro sondaggio settimanale!',
		takeTheSurvey: 'PARTECIPA AL SONDAGGIO',
		helpful: 'Utile',
		notHelpful: 'Non utile',


		pageMainButton: "Fai una domanda",
		faqVideoTitle: "Guarda il video su come inviare il tuo progetto di riferimento",
		translationsVideoTitle: "Guarda come funzionano le traduzioni e le convalide",
		questions: [
			{
				title: "Come posso inviare una storia di successo?",
				answer: "Puoi iniziare toccando il pulsante \"CONDIVIDI LA TUA STORIA DI SUCCESSO\" nella home page o cliccando sul pulsante \"Crea\" nel menu a sinistra mentre sei nella home page.",
				fileName: false,
				index: 1
			},
			{
				title: "Posso scaricare una storia di successo??",
				answer: "Sì, puoi scaricare un progetto di riferimento in formato Word, PDF o PPT aprendo la pagina del progetto e toccando il pulsante \"Scarica\"",
				fileName: false,
				index: 2
			},
			{
				title: "Posso inviare una storia di successo in una lingua diversa dall'inglese??",
				answer: "Posso inviare una storia di successo in una lingua diversa dall'inglese? Sì. Puoi inviare in tedesco, italiano, francese e giapponese. Se invii il tuo progetto in una delle lingue elencate, verrà tradotto automaticamente e poi modificato dal CMT in inglese. Dopo aver approvato la versione inglese del tuo progetto, questo verrà pubblicato e potrai rivederlo, modificarlo e convalidarlo in italiano, francese, giapponese e tedesco.",
				fileName: false,
				index: 3
			},
			{
				title: "Posso apportare modifiche alle traduzioni dei progetti pubblicati??",
				answer: "Sì. Puoi rivedere un progetto tradotto premendo 'Modifica la traduzione'. Se il progetto è già convalidato, puoi segnalare un problema in quel progetto.",
				fileName: false,
				index: 4
			},
			{
				title: "Quando verrà pubblicato il mio progetto??",
				answer: "Dopo aver inviato il tuo progetto, il content manager lo esaminerà, lo modificherà e te lo invierà per la tua revisione e approvazione. Dopo aver ricevuto la tua approvazione, il CMT pubblicherà la tua storia.",
				fileName: false,
				index: 5
			},
			{
				title: "Come posso segnalare un errore che vedo in una storia di successo??",
				answer: "Per segnalare un errore in una pagina di una storia, tocca il pulsante rosso \"Segnala un problema\" sopra il menu laterale a destra.",
				fileName: false,
				index: 6
			},
			{
				title: "Posso visualizzare in anteprima i progetti in altre lingue??",
				answer: "Sì. Quando apri una pagina di una storia, puoi cambiarne la lingua premendo l'icona lingua/paese nel menu di navigazione in alto a destra.",
				fileName: false,
				index: 7
			}
		]
	},
	[LANGUAGE.ja.short]: {
		resources: 'リソース',
		description: 'プラットフォームの操作に役立つコンテンツ資産にアクセスします',
		nowPlaying: '再生中',
		upNext: '次回',
		watchMore: 'その他の動画を見る',
		videoTypes: {
			popular: '人気記事',
			howSubmitStory: 'ストーリーの投稿方法',
			features: '特集',
			howSearch: '効果的な検索方法'
		},
		curatedForYou: 'あなたのために厳選',
		download: 'ダウンロード',
		pageTitle: "FAQs",
		contact: '探していたものが見つかりませんでしたか？お気軽にご質問ください。',
		submit: '提出する',
		questionPlaceholder: 'ここにメッセージを入力してください',
		helpUs: 'より良いサービスを目指して',
		weListening: '皆様の声をお待ちしております！毎週のアンケートにご協力ください！',
		takeTheSurvey: 'アンケートにご協力ください',
		helpful: '役に立った',
		notHelpful: '役に立たなかった',


		pageMainButton: "質問する",
		faqVideoTitle: "クライアントストーリーの提出方法ビデオを見る",
		translationsVideoTitle: "翻訳と検証の方法を見る",
		questions: [
			{
				title: "成功事例を提出するにはどうすればいいですか?",
				answer: "ホームページの「成功ストーリーを共有」ボタンをタップするか、ホームページの左側のメニューにある「作成」ボタンをクリックして開始できます。",
				fileName: false,
				index: 1
			},
			{
				title: "成功事例をダウンロードできますか？",
				answer: "はい、プロジェクト ページを開いて [ダウンロード] ボタンをタップすると、Word、PDF、または PPT 形式で参照プロジェクトをダウンロードできます。",
				fileName: false,
				index: 2
			},
			{
				title: "英語以外の言語で成功事例を提出できますか?",
				answer: "はい。ドイツ語、イタリア語、フランス語、日本語で提出できます。記載されている言語のいずれかでプロジェクトを提出すると、自動翻訳され、CMT によって英語に編集されます。プロジェクトの英語版を承認すると公開され、イタリア語、フランス語、日本語、ドイツ語で確認、編集、検証できます。",
				fileName: false,
				index: 3
			},
			{
				title: "公開されたプロジェクトの翻訳に変更を加えることはできますか?",
				answer: "はい。「翻訳を編集」を押すことで、翻訳されたプロジェクトを修正できます。プロジェクトがすでに検証されている場合は、そのプロジェクトの問題を報告できます。",
				fileName: false,
				index: 4
			},
			{
				title: "私のプロジェクトはいつ公開されますか?",
				answer: "プロジェクトを提出すると、コンテンツ マネージャーがそれを確認および編集し、確認と承認のためにお客様に送信します。承認を受けた後、CMT はストーリーを公開します。",
				fileName: false,
				index: 5
			},
			{
				title: "成功事例で見つけたエラーを報告するにはどうすればよいですか?",
				answer: "ストーリー ページのエラーを報告するには、右側のサイド メニューの上にある赤い [問題を報告] ボタンをタップします。",
				fileName: false,
				index: 6
			},
			{
				title: "他の言語でプロジェクトをプレビューできますか?",
				answer: "はい。ストーリー ページを開いたときに、右上のナビゲーション メニューにある言語/国アイコンを押すと、言語を変更できます。",
				fileName: false,
				index: 7
			}
		]
	},
	[LANGUAGE.es.short]: {
		resources: 'RECURSOS',
		description: 'Accede a recursos de contenido útiles para ayudarte a navegar por nuestra plataforma',
		nowPlaying: 'AHORA SONANDO',
		upNext: 'PRÓXIMAMENTE',
		watchMore: 'Ver más videos',
		videoTypes: {
			popular: 'Popular',
			howSubmitStory: 'Cómo enviar una historia',
			features: 'Características',
			howSearch: 'Cómo buscar de manera efectiva'
		},
		curatedForYou: 'Seleccionado para ti',
		download: 'Descargar',
		pageTitle: "FAQs",
		contact: '¿No encontraste lo que buscabas? No dudes en hacer una pregunta.',
		submit: 'Enviar',
		questionPlaceholder: 'Escribe tu mensaje aquí',
		helpUs: 'Ayúdanos a mejorar tu experiencia.',
		weListening: '¡Te estamos escuchando! ¡Participa en nuestra encuesta semanal!',
		takeTheSurvey: 'REALIZA LA ENCUESTA',
		helpful: 'Útil',
		notHelpful: 'No útil',
		pageMainButton: "Haz una pregunta",
		faqVideoTitle: "Ver cómo enviar tu proyecto de referencia",
		translationsVideoTitle: "Ver cómo funcionan las traducciones y validaciones",
		questions: [
			{
				title: "¿Cómo puedo enviar una historia de éxito?",
				answer: "Puedes comenzar tocando el botón 'COMPARTIR TU HISTORIA DE ÉXITO' en la página de inicio o haciendo clic en el botón 'Crear' en el menú de la izquierda mientras estás en la página de inicio.",
				fileName: false,
				index: 1
			},
			{
				title: "¿Puedo descargar una historia de éxito?",
				answer: "Sí, puedes descargar un proyecto de referencia en formato Word, PDF o PPT abriendo la página del proyecto y tocando el botón 'Descargar'.",
				fileName: false,
				index: 2
			},
			{
				title: "¿Puedo enviar una historia de éxito en un idioma diferente al inglés?",
				answer: "Sí. Puedes enviar en alemán, italiano, francés y japonés. Si envías tu proyecto en uno de los idiomas enumerados, se traducirá automáticamente y luego será editado por el CMT en inglés. Después de aprobar la versión en inglés de tu proyecto, se publicará y podrás revisarlo, editarlo y validarlo en italiano, francés, japonés y alemán.",
				fileName: false,
				index: 3
			},
			{
				title: "¿Puedo hacer cambios a las traducciones de proyectos publicados?",
				answer: "Sí. Puedes revisar un proyecto traducido presionando 'Editar la traducción'. Si el proyecto ya está validado, puedes informar un problema en ese proyecto.",
				fileName: false,
				index: 4
			},
			{
				title: "¿Cuándo se publicará mi proyecto?",
				answer: "Después de enviar tu proyecto, el administrador de contenido lo revisará y editará y te lo enviará para su revisión y aprobación. Una vez que recibas tu aprobación, el CMT publicará tu historia.",
				fileName: false,
				index: 5
			},
			{
				title: "¿Cómo puedo informar un error que veo en una historia de éxito?",
				answer: "Para informar un error en una página de historia, toca el botón rojo 'Informar un problema' sobre el menú lateral derecho.",
				fileName: false,
				index: 6
			},
			{
				title: "¿Puedo previsualizar proyectos en otros idiomas?",
				answer: "Sí. Cuando abres una página de historia, puedes cambiar su idioma presionando el ícono de idioma/país en el menú de navegación en la parte superior derecha.",
				fileName: false,
				index: 7
			}
		]
	}
}
